export const BOOK_VISIT = "https://form.jotform.com/250684259450158";
export const ATHENA_PORTAL = "https://31312-1.portal.athenahealth.com/";
export const YOSI_WIDGET_SCRIPT =
  "https://s3-us-west-2.amazonaws.com/s3-schedulewidget.yosicare.com/script.js";
export const YOSI_WIDGET_ID = "4fa0b9451c6bed737da10459f752aec7";
export const ELEKTRA_FEED = "https://elektrahealth.mn.co/spaces/9296667/feed";
export const ELEKTRA_EVENTS =
  "https://elektrahealth.mn.co/spaces/9296667/events";
export const COACH_CTA =
  "https://schedule.yosicare.com/d4a3d35b0c8792867b2b0bdb9651bc82";
